'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LocalStreamingLog = require('./LocalStreamingLog');

var _LocalStreamingLog2 = _interopRequireDefault(_LocalStreamingLog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = new _LocalStreamingLog2.default(); /*
                                             Usage:
                                             
                                             eventBus.getTopic("myEvent").subscribe(message => doThingWith(message));
                                             
                                             ... meanwhile, elsewhere ...
                                             
                                             eventBus.publish("myEvent", { some: "Interesting", data: 4, which: 2, do: "Things with" });
                                             
                                              */

var eventBus = {
    id: Math.random(), // useful for when you want to debug whether the bus is unique or not.
    publish: function publish(topic, message) {
        // console.log(`${this.id} publishing ${message} on ${topic}`)
        log.publish(topic, JSON.stringify(message));
    },
    getTopic: function getTopic(topic) {
        var id = this.id;
        return log.getTopic(topic).map(function (msg) {
            // console.log(`${id} got ${msg} on ${topic}`);
            return JSON.parse(msg);
        });
    }
};

exports.default = eventBus;


//////////////////
// WEBPACK FOOTER
// ../~/event-bus-rx/lib/eventBus.js
// module id = 708
// module chunks = 0